import React from "react";
import styles from "./CertificationsSection.module.css";
import { motion } from "framer-motion";

const CertificationsSection = ({ logoIGI, logoJBT, logoVDB }) => (
  <motion.section
    className={styles.certificationsSection}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.7, type: "spring", stiffness: 60 }}
  >
    <div className={styles.CertificatesRow}>
      <motion.img
        src={logoIGI}
        alt="IGI Certification Logo"
        className={styles.certLogo}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      />
      <motion.img
        src={logoJBT}
        alt="JBT Certification Logo"
        className={styles.certLogo}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5, delay: 0.25 }}
      />
      <motion.img
        src={logoVDB}
        alt="VDB Certification Logo"
        className={styles.certLogo}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      />
    </div>
  </motion.section>
);

export default CertificationsSection;
